<button
  class="fdk-button fdk-button--{{ variant }} fdk-type-label-large"
  [class.fdk-button--full-width]="width === 'full'"
  [disabled]="disabled"
  [type]="type">
  <ng-content></ng-content>
</button>
